import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSearchSelectedLocationtext } from "../../../store/formsubmitted";
import { RootState } from "../../../store/rootReducer";

export const LocationSelectedSearchBar = () => {
    const dispatch = useDispatch();
    const selectedSearchText = useSelector((state: RootState) => state.formSubmittedSlice.searchSelectedLocationText);

    return (
        <IonSearchbar
            value={selectedSearchText}
            onIonChange={({ detail: { value = "" } }) => {
                dispatch(setSearchSelectedLocationtext(value));
            }}
            debounce={700}
            placeholder={"Buscar en instalaciones seleccionadas..."}
            autocomplete="off"
        />
    );
};
